import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';
import { useWallet } from '@txnlab/use-wallet-react';
import api from '../api';
import dropClient from '../state/dropClient.js';
import { discountToken, countdown } from '../state/index.js';
import TurnstileGate from './TurnstileGate.jsx';

// Integration point between the client-side wallet (use-wallet), the mobx stores,
// and cf-backend. Replaces the old server-side-WebSocket bootstrap.
function TheApi({ account }) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { activeAddress, isReady } = useWallet();

  api.enqueueSnackbar = enqueueSnackbar;
  api.doCloseSnackbar = closeSnackbar;

  // One-time setup: wire the drop client to the discount-token store and start
  // fetching the countdown time from cf-backend.
  useEffect(() => {
    dropClient.init(discountToken);
    // Show a notification the moment the cf-backend drops the free-claim token.
    dropClient.onToken = () =>
      api.enqueue('success', 'NFT claim token received!', 8000);
    api.getServerTime();
    const t = setInterval(() => api.getServerTime(), 60_000);
    return () => {
      clearInterval(t);
      dropClient.onToken = null;
    };
  }, []);

  // Mirror the connected wallet into the account store (drives ConnectButton and
  // the buy flow) and register the address with the cf-backend drop room.
  // account.address: null = wallet not resolved yet (spinner), false = no wallet,
  // string = connected.
  useEffect(() => {
    if (!isReady) return;
    account.setAddress(activeAddress || false);
    dropClient.setAddress(activeAddress || null);
  }, [activeAddress, isReady, account]);

  // Single, app-wide Turnstile widget so a token is always obtainable while a
  // wallet is connected — including after a WS reconnect on a page that doesn't
  // itself render the widget. interaction-only keeps it invisible unless a
  // challenge is actually required. Only mount it inside the drop window: outside
  // it the socket stays closed, so any token the widget produced would be wasted.
  return isReady && activeAddress && countdown.dropWindowOpen ? <TurnstileGate /> : null;
}

export default observer(TheApi);
